import * as types from '../actions/actionTypes';
import initialState from './initialState';
import * as storeConstants from '../store/constants';

const reducer = (state = initialState[storeConstants.JOB_FORM_VALID_SECTIONS], action) => {
  switch (action.type) {
    case types.JOB_FORM_UPDATE_VALID_SECTIONS: {
      const { sectionId, valid } = action.payload;
      return {
        ...state,
        [sectionId]: valid
      };
    }
    case types.JOB_FORM_CLEAR_SECTION_DATA: {
      return { ...initialState[storeConstants.JOB_FORM_VALID_SECTIONS] };
    }
    case types.JOB_FORM_SET_VALID_SECTIONS: {
      initialState[storeConstants.JOB_FORM_VALID_SECTIONS] = action.payload;
      return { ...initialState[storeConstants.JOB_FORM_VALID_SECTIONS] };
    }
    default:
      return state;
  }
};

export default reducer;
